// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import ContentBlock from '/react4xp/components/ContentBlock'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface HowWeAreProps {
    bgColor: 'green' | 'beige'
    tag?: string
    title?: string
    intro?: string
    contentBlock?: Array<{
        img: {
            srcSmall?: string
            srcMedium?: string
            src: string
            alt: string
        }
        title?: string
    }>
}

export default function HowWeAre({
    bgColor,
    tag,
    title,
    intro,
    contentBlock
}: HowWeAreProps) {
    return (
        <Section
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark'
            )}
            textColor='text-dark'
            className='how-we-are'
        >
            <div className='grid-container'>

                <div className='how-we-are__header'>
                    <div className='grid-row'>
                        <div className='c-md-10 start-md-2 c-lg-8 start-lg-3'>

                            {isNonWhitespaceString(tag) && (
                                <p className='tagline-md tagline'>
                                    {tag}
                                </p>
                            )}

                            {isNonWhitespaceString(title) && (
                                <h2 className='title-md title'>
                                    {title}
                                </h2>
                            )}

                            {isNonWhitespaceString(intro) && (
                                <div
                                    className='text-md intro'
                                    dangerouslySetInnerHTML={{ __html: intro }}
                                    suppressHydrationWarning
                                />
                            )}

                        </div>
                    </div>
                </div>

                {contentBlock && (
                    <div className='how-we-are__content-blocks'>
                        {contentBlock.map((item, i) => (
                            <div className='content-blocks__item' key={i}>
                                <ContentBlock
                                    img={item.img && {
                                        srcSmall: [`${item.img.srcSmall}`, 574], // 520x330
                                        srcMedium: [`${item.img.srcMedium}`, 991], // 450x450
                                        src: item.img.src, // 320x420
                                        alt: item.img.alt
                                    }}
                                    title={item.title}
                                />
                            </div>
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}

